import angular from 'angular'
import promoBodyComponent from './promoBody.component'

export default angular
  .module('ellipsis.promoBody', [])
  .component('promoBody', promoBodyComponent)
